import { render } from "./LegalDocumentFormModal.vue?vue&type=template&id=f5bd3092&scoped=true"
import script from "./LegalDocumentFormModal.vue?vue&type=script&lang=js"
export * from "./LegalDocumentFormModal.vue?vue&type=script&lang=js"

import "./LegalDocumentFormModal.vue?vue&type=style&index=0&id=f5bd3092&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5bd3092"]])

export default __exports__